import React from 'react';
import '../styles/InfoModal.css';

const InfoModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <div className="modal-header">
          <h2>Albert - Intelligent Tutoring System</h2>
        </div>
        <div className="modal-body">
          <section className="info-section">
            <h3>Cos'è Albert?</h3>
            <p>Albert è un intelligent tutoring system creato dal dottor Umberto Barbieri. Albert guida gli studenti attraverso il proprio ragionamento con domande mirate, incoraggiando un apprendimento attivo e una comprensione più profonda dei concetti.</p>
            <p>L'applicazione ha come obiettivo quello di migliorare i processi di apprendimento basandosi sulle più moderne scoperte di neuroscienze educative e psicologia dell'apprendimento.</p>
          </section>
          
          <section className="info-section">
            <h3>Approccio Educativo</h3>
            <p>Albert segue questi principi:</p>
            <ol>
              <li>Non risolve mai direttamente il problema per lo studente</li>
              <li>Pone domande che guidano il pensiero e il processo di ragionamento</li>
              <li>Fa notare incongruenze o errori attraverso domande e non correzioni dirette</li>
              <li>Richiama concetti precedenti quando appropriato</li>
              <li>Elogia il ragionamento corretto</li>
              <li>Mantiene un tono positivo e incoraggiante</li>
              <li>Adatta il livello delle domande in base al contesto</li>
            </ol>
          </section>
          
          <section className="info-section">
            <h3>Contatti</h3>
            <p>Per informazioni, assistenza o proposte di collaborazione:</p>
            <ul className="contact-list">
              <li><strong>Email:</strong> <a href="mailto:info@studywithalbert.com">info@studywithalbert.com</a></li>
              <li><strong>Sito web:</strong> <a href="https://www.studywithalbert.com" target="_blank" rel="noopener noreferrer">www.studywithalbert.com</a></li>
              <li><strong>Collaborazioni Scientifiche</strong> <a href="mailto:umberto.barbieri@unipegaso.it">umberto.barbieri@unipegaso.it</a></li>
          
            </ul>
          </section>
          
          <section className="info-section">
            <h3>Sviluppo e Tecnologia</h3>
            <p>Albert utilizza modelli di linguaggio avanzati e algoritmi di machine learning per fornire assistenza personalizzata. La piattaforma è stata sviluppata per essere accessibile, performante e facile da usare, supportando diverse branche del sapere e settori disciplinari.</p>
            <p>© {new Date().getFullYear()} Tutti i diritti riservati.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default InfoModal;